import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

export type ApplyTemplateConfirmationModalProps = {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ApplyTemplateConfirmationModal: FC<ApplyTemplateConfirmationModalProps> = ({ show, onConfirm, onCancel }) => (
    <Modal
        size="large"
        id="apply-template-confirmation-modal"
        data-testid="apply-template-confirmation-modal"
        show={show}
        header={
            <Typography variant="h3" data-testid="apply-template-confirmation-modal-header">
                Apply this template?
            </Typography>
        }
        onHide={onCancel}
        footer={{
            layout: 'rightAligned',
            options: {
                action: onCancel,
                label: 'Cancel',
                buttonStyle: 'tertiary'
            },
            primary: {
                action: onConfirm,
                label: 'Apply template'
            }
        }}
    >
        <Typography variant="body-md" tag="div" data-testid="apply-template-confirmation-modal-content">
            This will replace your current scenarios with the template. Do you want to continue?
        </Typography>
    </Modal>
);
